var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00004 10.3333C2.92052 10.3333 3.66671 11.0795 3.66671 12C3.66671 12.9205 2.92052 13.6667 2.00004 13.6667C1.07957 13.6667 0.333374 12.9205 0.333374 12C0.333374 11.0795 1.07957 10.3333 2.00004 10.3333ZM2.00004 5.33334C2.92052 5.33334 3.66671 6.07954 3.66671 7.00001C3.66671 7.92048 2.92052 8.66668 2.00004 8.66668C1.07957 8.66668 0.333374 7.92048 0.333374 7.00001C0.333374 6.07954 1.07957 5.33334 2.00004 5.33334ZM2.00004 0.333344C2.92052 0.333344 3.66671 1.07954 3.66671 2.00001C3.66671 2.92048 2.92052 3.66668 2.00004 3.66668C1.07957 3.66668 0.333374 2.92048 0.333374 2.00001C0.333374 1.07954 1.07957 0.333344 2.00004 0.333344Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d21baaa6cdb3605649474817f2faf33d.svg";
export { ForwardRef as ReactComponent };